import React from 'react';

import Box from '@amzn/meridian/box';
import Textarea from '@amzn/meridian/textarea';

// **** Types **** //

interface FreeFormProps {
  value: string;
  onChange: (string: string) => void;
  isDisabled: boolean;
  errorMessage: string | undefined;
  /** @testOnly */
  index: number;
}

// **** Components **** //

/**
 * Select hours value available based on the shift length.
 */
const FreeFormSelector = ({ value, onChange: onChange, isDisabled, errorMessage, index }: FreeFormProps) => {
  return (
    <Box>
      <Textarea
        aria-label="Additional Details"
        data-cy={`new-jmr__restrictions__free-form-selector__${index}`}
        placeholder="Enter free text..."
        constraintText={`${value.length} of 255 Characters`}
        value={value}
        onChange={(value: string) => onChange(value.slice(0, 255))}
        errorMessage={errorMessage}
        error={!!errorMessage}
        disabled={isDisabled}
      />
    </Box>
  );
};

// **** Export **** //

export default FreeFormSelector;
